import { i18n } from '@lingui/core'

export function workOrderDate(value: string): string {
  if (!value || Number.isNaN(Date.parse(value))) return value
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return i18n.date(new Date(value), { dateStyle: 'medium', timeZone: 'UTC' })
  }
  return `${i18n.date(new Date(value), { dateStyle: 'medium', timeStyle: 'medium', timeZone: 'UTC' })} UTC`
}
